import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '594px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingBottom: '12px'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '34px 0 0',
    width: '100%',
    gap: '10px'
  },
  deleteButton: {
    backgroundColor: '#be1224',
    transition: 'background-color 0.3s ease', // Adiciona uma transição suave para o hover
    '&:hover': {
      backgroundColor: 'rgba(190, 18, 36, 0.8)' // Cor mais clara com transparência
    }
  }
}));
